<template>
  <div class="brb-input flex-grow-1">
    <brb-input-group
      :size="size"
      :prepend="label"
      :append="append"
      :required="required"
      v-bind="$attrs"
    >
      <template v-if="!!$slots.prepend" #prepend>
        <slot name="prepend"></slot>
      </template>

      <template v-if="!!$slots.append" #append>
        <slot name="append"></slot>
      </template>

      <numeric-input
        ref="brb-input"
        v-if="numeric || mobile || phone || nationalId"
        v-model="model"
        v-bind="$attrs"
        :disabled="disabled"
        :input-class="computedInputClass"
        :input-style="inputStyle"
        :separator="separateNumbers"
        :mobile="mobile"
        :phone="phone"
        :national-id="nationalId"
        :string-output="stringOutput"
        :tabindex="tabindex"
        v-on="$listeners"
      />

      <b-textarea
        ref="brb-input"
        v-else-if="textarea"
        :id="id"
        v-model="model"
        :class="computedInputClass"
        :style="inputStyle"
        :disabled="disabled"
        :tabindex="tabindex"
        v-bind="$attrs"
        v-on="$listeners"
      />

      <date-picker
        v-else-if="date"
        :id="id"
        v-model="model"
        v-bind="$attrs"
        :class="computedInputClass"
        :disabled="disabled"
        :type="type"
        :size="size"
        :tabindex="tabindex"
      />

      <time-input
        v-else-if="time"
        :id="id"
        v-model="model"
        v-bind="$attrs"
        :input-class="computedInputClass"
        :disabled="disabled"
        :tabindex="tabindex"
      />

      <b-input
        ref="brb-input"
        v-else
        :id="id"
        v-model="model"
        :autocomplete="autocomplete"
        :class="computedInputClass"
        :style="inputStyle"
        :disabled="disabled"
        v-bind="$attrs"
        :type="type"
        :tabindex="tabindex"
        :dir="dir"
        v-on="$listeners"
      />
    </brb-input-group>

    <span
      v-if="!noError && error && typeof error === 'string'"
      class="d-block text-right text-danger small mt-2"
    >
      {{ error }}
    </span>

    <!-- Todo: check -->
    <span v-if="currency && model" class="d-block text-right small mt-2">
      {{ changeRialToToman(model) }}
    </span>
  </div>
</template>

<script>
import { convertRialToToman } from '@/lib/util'

export default {
  name: 'BrbInput',
  components: {
    BrbInputGroup: () => import('./BrbInputGroup.vue'),
    NumericInput: () => import('@/components/shared/NumericInput.vue'),
    DatePicker: () => import('@/components/shared/DatePicker.vue'),
    TimeInput: () => import('@/components/shared/TimeInput.vue')
  },
  props: {
    id: {
      type: String
    },
    type: String,
    value: {
      default: null
    },
    label: {
      required: false
    },
    size: {
      type: String,
      default: 'md'
    },
    append: String,
    autocomplete: {
      type: String,
      default: 'off'
    },
    inputClass: {
      type: [String, Object, Array]
    },
    inputStyle: {
      type: [String, Object, Array]
    },
    error: {
      type: [Boolean, String]
    },
    inputGroupClass: {
      type: [String, Array, Object],
      default: null
    },
    inputGroupStyle: {
      type: [String, Array, Object],
      default: null
    },
    dir: String,
    required: Boolean,
    numeric: Boolean,
    stringOutput: Boolean,
    mobile: Boolean,
    phone: Boolean,
    nationalId: Boolean,
    date: Boolean,
    separateNumbers: Boolean,
    textarea: Boolean,
    disabled: Boolean,
    time: Boolean,
    tabindex: String,
    noError: Boolean,
    currency: Boolean
  },
  computed: {
    model: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      }
    },
    computedInputClass() {
      return [
        { 'invalid-input': this.error },
        this.inputClass ? this.inputClass : 'bg-white'
      ]
    }
  },
  methods: {
    changeRialToToman(value) {
      return convertRialToToman(value)
    },
    focus() {
      if (this.$refs['brb-input']) this.$refs['brb-input'].focus()
    }
  }
}
</script>
